import toThreadTimestampMs from '@/lib/threads/toThreadTimestampMs.js';

const sortThreadBranchesByLatestActivity = ({ items = [], sortBy = 'created' } = {}) => {
  const shouldSortByUpdatedAt =
    String(sortBy || '')
      .trim()
      .toLowerCase() === 'updated';
  const getPrimarySortTimestamp = (item = {}) => {
    if (shouldSortByUpdatedAt) {
      return toThreadTimestampMs(item?.updatedAt) || 0;
    }

    return toThreadTimestampMs(item?.createdAt) || 0;
  };
  const compareThreadBranchItems = (left, right) => {
    const rightBranchTs = Number(right?.branchLatestTs || 0);
    const leftBranchTs = Number(left?.branchLatestTs || 0);

    if (rightBranchTs !== leftBranchTs) {
      return rightBranchTs - leftBranchTs;
    }

    const rightSelfTs = getPrimarySortTimestamp(right);
    const leftSelfTs = getPrimarySortTimestamp(left);

    if (rightSelfTs !== leftSelfTs) {
      return rightSelfTs - leftSelfTs;
    }

    return String(right?.id || '').localeCompare(String(left?.id || ''));
  };
  const normalizeBranch = (item = {}) => {
    const normalizedChildren = (item?.childThreadItems || []).map((child) => normalizeBranch(child));
    normalizedChildren.sort(compareThreadBranchItems);
    const ownPrimaryTs = getPrimarySortTimestamp(item);
    const childLatestTs = normalizedChildren.reduce((latestTs, childItem) => {
      const childBranchLatestTs = Number(childItem?.branchLatestTs || 0);
      return childBranchLatestTs > latestTs ? childBranchLatestTs : latestTs;
    }, 0);
    const branchLatestTs = Math.max(ownPrimaryTs, childLatestTs);

    return {
      ...item,
      childThreadItems: normalizedChildren,
      branchLatestTs
    };
  };
  const stripBranchMetadata = (item = {}) => {
    const rest = { ...item };
    delete rest.branchLatestTs;

    return {
      ...rest,
      childThreadItems: (item?.childThreadItems || []).map((child) => stripBranchMetadata(child))
    };
  };
  const normalizedItems = (items || []).map((item) => normalizeBranch(item));
  normalizedItems.sort(compareThreadBranchItems);

  return normalizedItems.map((item) => stripBranchMetadata(item));
};

export default sortThreadBranchesByLatestActivity;
